<template>
  <div class="shipment">
    <h4 class="stock-location" data-hook="stock-location">
      Shipping From {{ shippingOrigin }}
      <a :href="carbonNeutralLink" class="carbon-neutral-note">
        Carbon Neutral Shipping
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2px"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          xml:space="preserve"
          class="carbon-neutral-icon"
        >
          <path d="M4,20C3,8,8,3,20,4c1,12-4,17-16,16l8-8Z" />
        </svg>
      </a>
    </h4>

    <template v-if="unshippableByAirVariants.length > 0">
      <div class="alert alert-warning unshippable-by-air-warning">
        The following variant(s) are unshippable by air:
        <ul>
          <li v-for="(variant, index) in unshippableByAirVariants" :key="index">
            {{ variant.name }}
          </li>
        </ul>
      </div>
    </template>

    <div
      v-for="(message, messageType) in messages"
      :key="messageType"
      :class="`alert alert-warning ${messageType}-warning`"
    >
      <strong>{{ message.title }}</strong>
      {{ message.text }}
    </div>
    <shipping-rates :shipping-rates="shippingRates" />
  </div>
</template>

<script>
  import ShippingRates from "./shipping-rates"

  export default {
    components: {
      ShippingRates,
    },
    props: {
      unshippableByAirVariants: {
        type: Array,
        required: false,
        default() {
          return []
        },
      },
      messages: {
        type: Object,
        required: false,
        default() {
          return {}
        },
      },
      shippingOrigin: {
        type: String,
        required: true,
      },
      shippingRates: {
        type: Array,
        required: false,
        default() {
          return []
        },
      },
    },
    data() {
      return {
        carbonNeutralLink:
          // eslint-disable-next-line max-len
          "http://support.candlescience.com/hc/en-us/articles/201199850-What-exactly-does-Carbon-Neutral-mean-",
      }
    },
  }
</script>

<style scoped>
  .stock-location,
  .carbon-neutral-note {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .stock-location {
    width: 100%;
  }

  .carbon-neutral-note {
    text-align: right;
    color: #3e8606;
    margin-left: auto;
    font-size: 14px;
    font-weight: normal;
  }

  .carbon-neutral-icon {
    color: inherit;
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }
</style>
